<template>
  <div class="buy-button-base">
    <base-button
      :label="buttonFace"
      :is-disabled="isDisabled"
      @clicked="onBtnClick"
    />
  </div>
</template>

<script>

import BaseButton from '@/utvStore/components/common/BaseButton'
export default {
  name: "BuyButton",
  components: {BaseButton},
  data() {
    return {
      lock: false
    }
  },
  props: {
    linkUrl: {
      type: String,
      default() {
        return ''
      }
    },
    forceDisable: {
      type: Boolean,
      default() {
        return false
      }
    },
    userProfile: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    isDisabled(){
      if(!!this.userProfile && !!this.userProfile.subscription){
        const subsc = this.userProfile.subscription
        const stat =parseInt(subsc.status)
        if(parseInt(subsc.active) === 1 && (stat > 0 && stat !== 2 && stat !== 4) && parseInt(subsc.free_buy) > 0){
          return false
        }
      }
      return true
    },
    buttonFace(){
      return '申し込み'
    }
  },
  created() {
    dbg.info('[check user profile] %O', this.userProfile)
  },
  methods: {
    onBtnClick() {
      if(!this.lock){
        this.lock = true
        location.href = this.linkUrl
      }
    }
  }
}</script>

<style scoped lang="scss">
.buy-button-base {
  padding: 8px 0;
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/partials/BuyButton.vue